import { useCallback, useMemo, useState } from 'react';
import { Tabs } from '@carboledger/ui';
import { SitesTable } from './SitesTable';
import { BackToBackAccountsTable } from './BackToBackAccountsTable';
import { useTranslations } from '@/hooks';
import {
  STRUCTURE_TABS,
  DEFAULT_STRUCTURE_TAB,
  buildStructureTabs,
} from '../../constants/accountSetup.constants';
import styles from './CompanyStructureSection.module.scss';

export const CompanyStructureSection = () => {
  const t = useTranslations();
  const [activeTab, setActiveTab] = useState(DEFAULT_STRUCTURE_TAB);

  const tabs = useMemo(() => buildStructureTabs(t), [t]);
  const handleTabChange = useCallback((tab) => setActiveTab(tab), []);

  return (
    <div className={styles.section}>
      <div className={styles.tabs}>
        <Tabs
          tabs={tabs}
          value={activeTab}
          onChange={handleTabChange}
          bordered
          aria-label={t('ACCOUNT_SETUP_TAB_COMPANY_STRUCTURE')}
        />
      </div>

      {activeTab === STRUCTURE_TABS.sites && <SitesTable />}

      {activeTab === STRUCTURE_TABS.backToBackAccounts && <BackToBackAccountsTable />}
    </div>
  );
};
